import * as React from "react";
import { Check, Minus } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
const comparisonData = [{
  feature: "Custom-Fitted Comfort",
  somna: true,
  cpap: false,
  mouthguard: false
}, {
  feature: "Silent & Hose-Free",
  somna: true,
  cpap: false,
  mouthguard: true
}, {
  feature: "Travel-Friendly Design",
  somna: true,
  cpap: false,
  mouthguard: true
}, {
  feature: "Allows Natural Movement",
  somna: true,
  cpap: false,
  mouthguard: true
}, {
  feature: "Clinically Proven Results",
  somna: true,
  cpap: true,
  mouthguard: false
}, {
  feature: "Medical Insurance Coverage",
  somna: true,
  cpap: true,
  mouthguard: false
}, {
  feature: "High Long-Term Compliance",
  somna: true,
  cpap: false,
  mouthguard: false
}];
export default function TheSomnaDifference() {
  return <section data-section-id="99168" id="a-better-way-to-sleep" className="bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-secondary/5 rounded-full blur-[120px] pointer-events-none" />

      <div className="max-w-5xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-sans font-bold tracking-tight mb-6 text-primary">
            A Better Way to Sleep
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg md:text-xl leading-relaxed">
            Compare the bulky, restrictive nature of traditional CPAP machines with the sleek, 
            custom-fitted comfort of modern Oral Appliance Therapy. We prioritize your rest 
            without compromising clinical efficacy.
          </p>
        </div>

        <div className="bg-card/80 backdrop-blur-xl rounded-3xl border border-border overflow-hidden shadow-xl shadow-primary/5">
          <Table className="min-w-[700px]">
            <TableHeader className="bg-muted/40">
              <TableRow className="hover:bg-transparent border-b-border">
                <TableHead className="w-[40%] py-8 px-8 text-base font-semibold text-primary">
                  Treatment Feature
                </TableHead>
                <TableHead className="w-[20%] py-8 px-6 text-center text-secondary font-bold text-lg bg-secondary/5 border-x border-secondary/10">
                  Oral Appliance
                </TableHead>
                <TableHead className="w-[20%] py-8 px-6 text-center text-primary/70 font-semibold text-base">
                  Traditional CPAP
                </TableHead>
                <TableHead className="w-[20%] py-8 px-6 text-center text-muted-foreground font-medium text-base">
                  OTC Mouthguards
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {comparisonData.map((row, i) => <TableRow key={i} data-index={i} className="border-b-border hover:bg-secondary/5 transition-colors group">
                  <TableCell className="py-6 px-8 font-medium text-foreground/90 group-hover:text-primary transition-colors">
                    {row.feature}
                  </TableCell>
                  <TableCell className="py-6 px-6 text-center bg-secondary/5 border-x border-secondary/10">
                    {row.somna ? <div className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-secondary/20 text-secondary">
                        <Check className="w-5 h-5" strokeWidth={3} />
                      </div> : <Minus className="w-5 h-5 text-destructive/30 mx-auto" />}
                  </TableCell>
                  <TableCell className="py-6 px-6 text-center">
                    {row.cpap ? <Check className="w-5 h-5 text-primary/40 mx-auto" /> : <Minus className="w-5 h-5 text-destructive/40 mx-auto" />}
                  </TableCell>
                  <TableCell className="py-6 px-6 text-center">
                    {row.mouthguard ? <Check className="w-5 h-5 text-muted-foreground/40 mx-auto" /> : <Minus className="w-5 h-5 text-muted-foreground/20 mx-auto" />}
                  </TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </div>
      </div>
    </section>;
}